
export const l_storage = {

  set: (key: string, value: string) => {
    if (value) {
      localStorage.setItem(key, JSON.stringify(value));
    }
  },
  
  get: (key: string) => {
    const value = localStorage.getItem(key);
  
    if (value) return JSON.parse(value);
  
    return undefined;
  },
  remove: (key: string) => localStorage.removeItem(key),
  
  clear: () => localStorage.clear()
};


export const s_storage = {

  set: (key: string, value: string) => {
    if (value) {
      sessionStorage.setItem(key, JSON.stringify(value));
    }
  },
  
  get: (key: string) => {
    const value = sessionStorage.getItem(key);
  
    if (value) return JSON.parse(value);
  
    return undefined;
  },
  remove: (key: string) => sessionStorage.removeItem(key),
  
  clear: () => sessionStorage.clear()
};

